import React, { Component } from "react";
import {
    MDBBtn,
    MDBModalBody,
    MDBModalHeader,
    MDBRow,
    MDBCol,
    MDBModal,
    toast,
    MDBProgress,
} from "mdbreact";
import CSVReader from "react-csv-reader";
import axios from "../../../../axios";
import SelectSearch, { fuzzySearch } from "react-select-search";
const papaparseOptions = {
    header: true,
    dynamicTyping: true,
    skipEmptyLines: true,
    quotes: true,
    encoding: "UTF-8",
    transformHeader: (header) => header.toLowerCase().replace(/\W/g, "_"),
};
class BulkUploadSubscribers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lastProcessed: undefined,
            venueID: undefined,
            venueUnitsData: undefined, // Separate state for unit data used in template
        };
    }
    componentDidMount() {
        this.props.getVenues();
    }
    componentDidUpdate(prevProps) {
        // if (this.state.venueID !== this.props.venueID) {
        //     this.getVenueDetails(this.props.venueID);
        //     this.setState({ venueID: this.props.venueID });
        // }
    }
    handleSelectChangeVenue = (venueID) => {
        if (venueID) {
            this.getVenueDetails(venueID);
            this.setState({ venueID: venueID });
        } else {
            this.setState({
                venueID: undefined,
                venueUnitsData: undefined,
                allActiveData: undefined,
            });
        }
    };
    getVenueDetails = (index) => {
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            VenueID: index,
            UserTimeZone: new Date().getTimezoneOffset(),
        };
        this.setState({
            unitData: undefined,
            expiringData: undefined,
            searchData: undefined,
            value: "",
            defaultSubscriptionDurationRes: 0,
            loading_units: true,
        });
        axios
            .post("/venuemgmtconsole/venues/listVenueDetails", body, {
                headers: {},
            })
            .then((response) => {
                this.setState({
                    // allActiveData: response.data[index]["Units-Building-Floor-List-Subscribers"],
                    keyPoolID: Object.keys(response.data[index]["Keypools"]),
                    venueName: response.data[index]["VenueName"],
                });
                this.setState({
                    loading_units: false,
                });
                this.getVenueUnits(index);
            })
            .catch((error) => {
                this.getVenueDetails(index);
                this.setState({
                    error: true,
                    loading_units: false,
                });
            });
    };
    getVenueUnits = (index) => {
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            VenueID: index,
        };
        this.setState({
            unitData: undefined,
            expiringData: undefined,
            searchData: undefined,
            value: "",
            defaultSubscriptionDurationRes: 0,
            loading_units: true,
            allActiveData: undefined,
            venueUnitsData: undefined, // Clear venue units data
        });
        axios
            .post("/networkoperatorconsole/venues/listVenueUnits", body, {
                headers: {},
            })
            .then((response) => {
                this.setState({
                    allActiveData: response.data.VenueUnits,
                    venueUnitsData: response.data.VenueUnits, // Store units separately
                });
                this.setState({
                    loading_units: false,
                });
            })
            .catch((error) => {
                this.getVenueDetails(index);
                this.setState({
                    error: true,
                    loading_units: false,
                });
            });
    };
    sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }
    formatzip(num) {
        var s = "00000" + num;
        return s.substr(s.length - 5);
    }
    convertCSV = async (data) => {
        this.setState({ modalError: false });
        let dataImported = [];
        if (this.state.keyPoolID !== undefined) {
            this.setState({ 
             loading_upload: true,
             progress: 0
            });
            for (let i = 0; i < data.length; i++) {
                // Validate required fields
                const requiredFields = {
                    "unit_id_": "Unit ID",
                    "building_": "Building",
                    "floor_": "Floor",
                    "given_name_": "Given Name",
                    "family_name_": "Family Name",
                    "email_": "Email",
                    "start_date_": "Start Date",
                    "locale__en_us_": "Locale",
                    "contact_by_email___true_false_": "Contact by Email",
                    "contact_by_text___true_false_": "Contact by Text"
                };
                
                const missingFields = [];
                for (const [field, label] of Object.entries(requiredFields)) {
                    const value = data[i][field];
                    if (value === undefined || value === null || (typeof value === 'string' && value.trim() === "")) {
                        missingFields.push(label);
                    }
                }
                
                if (missingFields.length > 0) {
                    this.setState({
                        unitUnprocessed: data[i]["unit_id_"] || "N/A",
                        buildingUnprocessed: data[i]["building_"] || "N/A",
                        floorUnprocessed: data[i]["floor_"] || "N/A",
                        lastProcessed: i,
                        modalError: true,
                        errorMessage: `Missing required field(s): ${missingFields.join(", ")}`,
                        loading_upload: false
                    });
                    this.cancelUploadedFile();
                    return;
                }
                
                // Validate phone number format
                const phoneNumber = data[i]["phone___format___1xxxyyyzzzz_"];
                const phoneRegex = /^\+1\d{10}$/;
                if (!phoneRegex.test(phoneNumber)) {
                    this.setState({
                        unitUnprocessed: data[i]["unit_id_"] || "N/A",
                        buildingUnprocessed: data[i]["building_"] || "N/A",
                        floorUnprocessed: data[i]["floor_"] || "N/A",
                        lastProcessed: i,
                        modalError: true,
                        errorMessage: `Invalid phone number format. Expected format: +1xxxyyyzzzz (e.g., +15551234567)`,
                        loading_upload: false
                    });
                    this.cancelUploadedFile();
                    return;
                }
                
                // Validate contact preference fields
                const contactEmail = data[i]["contact_by_email___true_false_"];
                const contactText = data[i]["contact_by_text___true_false_"];
                const validBooleanValues = [true, false, "true", "false"];
                
                if (!validBooleanValues.includes(contactEmail)) {
                    this.setState({
                        unitUnprocessed: data[i]["unit_id_"] || "N/A",
                        buildingUnprocessed: data[i]["building_"] || "N/A",
                        floorUnprocessed: data[i]["floor_"] || "N/A",
                        lastProcessed: i,
                        modalError: true,
                        errorMessage: `Invalid "Contact by Email" value. Must be either "true" or "false"`,
                        loading_upload: false
                    });
                    this.cancelUploadedFile();
                    return;
                }
                
                if (!validBooleanValues.includes(contactText)) {
                    this.setState({
                        unitUnprocessed: data[i]["unit_id_"] || "N/A",
                        buildingUnprocessed: data[i]["building_"] || "N/A",
                        floorUnprocessed: data[i]["floor_"] || "N/A",
                        lastProcessed: i,
                        modalError: true,
                        errorMessage: `Invalid "Contact by Text" value. Must be either "true" or "false"`,
                        loading_upload: false
                    });
                    this.cancelUploadedFile();
                    return;
                }
                
                dataImported[i] = {
                    AccessToken: sessionStorage.getItem("AccessToken"),
                    IdToken: sessionStorage.getItem("IdToken"),
                    EmailAddress: data[i]["email_"],
                    KeyPoolID: this.state.keyPoolID[0],
                    GivenName: data[i]["given_name_"],
                    FamilyName: data[i]["family_name_"],
                    "PhoneNumber.E164":
                        data[i]["phone__format___1xxxyyyzzzz_"],
                    locale: data[i]["locale__en_us_"] || "en-us",
                    "EndDateTimeUTC.ISO8601": new Date(
                        data[i]["end_date"]
                    ).toISOString(),
                    "StartDateTimeUTC.ISO8601": new Date(
                        data[i]["start_date_"]
                    ).toISOString(),
                    VenueID: this.state.venueID,
                    contactpref_email:
                        data[i]["contact_by_email___true_false_"] === null
                            ? false
                            : data[i]["contact_by_email___true_false_"],
                    contactpref_sms:
                        data[i]["contact_by_text___true_false_"] === null
                            ? false
                            : data[i]["contact_by_text___true_false_"],
                    PolicyforSubscriberKey: {
                        UnitBuilding: data[i]["building_"],
                        UnitFloor: data[i]["floor_"],
                        UnitID: data[i]["unit_id_"],
                    },
                    UserTimeZone: new Date().getTimezoneOffset(),
                    externalSubscriberID: data[i]["external_subscriber_id"],
                    externalSubscriptionID: data[i]["external_subscription_id"],
                };
                let unitID = data[i]["unit_id_"];
                let building = data[i]["building_"];
                let floor = data[i]["floor_"];
                this.setState({ email: data[i]["email_"] });
                await axios
                    .post(
                        "/venuemgmtconsole/subscribers/addSubscriber",
                        dataImported[i],
                        {
                            headers: {},
                        }
                    )
                    .then(
                        (response) => {
                            toast.success(
                                "Unit " +
                                    unitID +
                                    ", Building " +
                                    building +
                                    ", Floor " +
                                    floor +
                                    " processed",
                                {
                                    closeButton: false,
                                }
                            );
                            if (i + 1 === data.length) {
                                this.props.updateName(
                                    this.state.venueName,
                                    this.state.venueID
                                );
                            }
                        },
                        (error) => {
                            this.setState({
                                unitUnprocessed: unitID,
                                buildingUnprocessed: building,
                                floorUnprocessed: floor,
                                lastProcessed: i + 1,
                            });
                            this.cancelUploadedFile();
                            i = data.length;
                            this.setState({
                                modalError: true,
                                errorMessage: error.response.data.message,
                            });
                        }
                    );
                this.setState({ progress: ((i + 1) / data.length) * 100 });
            }
            this.setState({ loading_upload: false });
        }
    };
    cancelUploadedFile() {
        const randomString = Math.random().toString(36);
        this.setState({
            theInputKey: randomString,
        });
    }
    toggleError = () => {
        this.setState({
            modalError: !this.state.modalError,
        });
    };
    convertToCSV(objArray) {
        var array =
            typeof objArray != "object" ? JSON.parse(objArray) : objArray;
        var str = "";
        for (var i = 0; i < array.length; i++) {
            var line = "";
            for (var index in array[i]) {
                if (line !== "") line += ",";
                line += '"' + array[i][index] + '"';
            }
            str += line + "\r\n";
        }
        return str;
    }
    exportCSVFile(headersExport, items, fileTitle) {
        if (headersExport !== items[0]) {
            items.unshift(headersExport);
        }
        // Convert Object to JSON
        var jsonObject = JSON.stringify(items);
        var csv = this.convertToCSV(jsonObject);
        var exportedFilename = fileTitle;
        // Add BOM for better UTF-8 compatibility with Excel
        var csvWithBOM = "\uFEFF" + csv;
        var blob = new Blob([csvWithBOM], { type: "text/csv;charset=utf-8;" });
        if (navigator.msSaveBlob) {
            // IE 10+
            navigator.msSaveBlob(blob, exportedFilename);
        } else {
            var link = document.createElement("a");
            if (link.download !== undefined) {
                // feature detection
                // Browsers that support HTML5 download attribute
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", exportedFilename);
                link.style.visibility = "hidden";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }
    render() {
        var headers = {
            unitID: "Unit ID*",
            unitBuilding: "Building*",
            unitFloor: "Floor*",
            SubscriberGivenName: "Given Name*",
            SubscriberFamilyName: "Family Name*",
            SubscriberEmail: "Email*",
            SubscriberLocale: "Locale (en-us)",
            SubscriberPhone: "Phone (Format: +1xxxyyyzzzz)",
            SubscriberAddress1: "Address 1",
            SubscriberAddress2: "Address 2",
            SubscriberCity: "City",
            SubscriberState: "State",
            SubscriberPostalCode: "Postal Code",
            SubsriberContactEmail: "Contact by Email* (true/false)",
            SubsriberContactSMS: "Contact by Text* (true/false)",
            StartDateTimeUTC: "Start Date*",
            EndDateTimeUTC: "End Date",
            SubscriberToken: "Subscriber Token",
            externalSubscriberID: "External Subscriber ID",
            externalSubscriptionID: "External Subscription ID",
        };
        var itemsFormatted = [];
        if (this.state.venueUnitsData !== undefined) {
            for (const key of Object.keys(this.state.venueUnitsData)) {
                itemsFormatted.push({
                    unitID: this.state.venueUnitsData[key]["UnitID"],
                    unitBuilding: this.state.venueUnitsData[key]["UnitBuilding"],
                    unitFloor: this.state.venueUnitsData[key]["UnitFloor"],
                    SubscriberGivenName: "",
                    SubscriberFamilyName: "",
                    SubscriberEmail: "",
                    SubscriberLocale: "",
                    SubscriberPhone: "",
                    SubscriberAddress1:
                        this.state.venueUnitsData[key]["AddressLine1"],
                    SubscriberAddress2:
                        this.state.venueUnitsData[key]["AddressLine2"],
                    SubscriberCity: this.state.venueUnitsData[key]["City"],
                    SubscriberState: this.state.venueUnitsData[key]["State"],
                    SubscriberPostalCode:
                        this.state.venueUnitsData[key]["PostalCode"],
                    SubsriberContactEmail: "",
                    SubsriberContactSMS: "",
                    StartDateTimeUTC: "",
                    EndDateTimeUTC: "",
                    SubscriberToken: "",
                    externalSubscriberID: "",
                    externalSubscriptionID: "",
                });
            }
        }
        var fileTitle = "Subscriber_Upload_Template.csv"; // or 'my-unique-title'
        return (
            <>
                {this.state.lastProcessed !== undefined ? (
                    <>
                        <MDBModal
                            isOpen={this.state.modalError}
                            toggle={this.toggle}
                            size="md"
                            className="form"
                            centered
                        >
                            <MDBModalHeader toggle={this.toggleError}>
                                <h4>Error Uploading Subscribers</h4>
                            </MDBModalHeader>
                            <MDBModalBody>
                                {this.state.lastProcessed === 0 ? (
                                    <p>
                                        Line {this.state.lastProcessed + 2}{" "}
                                        (Unit: {this.state.unitUnprocessed},
                                        Building:{" "}
                                        {this.state.buildingUnprocessed}, Floor:{" "}
                                        {this.state.floorUnprocessed}) could not
                                        be processed.
                                        <br />
                                        Reason: {this.state.errorMessage}
                                        <br />
                                        Re-upload the CSV after fixing line {this.state.lastProcessed + 2}.
                                    </p>
                                ) : this.state.lastProcessed === 1 ? (
                                    <p>
                                        Line {this.state.lastProcessed + 2}{" "}
                                        (Unit: {this.state.unitUnprocessed},
                                        Building:{" "}
                                        {this.state.buildingUnprocessed}, Floor:{" "}
                                        {this.state.floorUnprocessed}) could not
                                        be processed.
                                        <br />
                                        Reason: {this.state.errorMessage}
                                        <br />
                                        Re-upload the CSV after fixing line{" "}
                                        {this.state.lastProcessed + 2} and removing line 2.
                                    </p>
                                ) : (
                                    <p>
                                        Line {this.state.lastProcessed + 2}{" "}
                                        (Unit: {this.state.unitUnprocessed},
                                        Building:{" "}
                                        {this.state.buildingUnprocessed}, Floor:{" "}
                                        {this.state.floorUnprocessed}) could not
                                        be processed.
                                        <br />
                                        Reason: {this.state.errorMessage}
                                        <br />
                                        Re-upload the CSV after fixing line{" "}
                                        {this.state.lastProcessed + 2} and
                                        removing lines 2-
                                        {this.state.lastProcessed + 1}.
                                    </p>
                                )}
                            </MDBModalBody>
                        </MDBModal>
                    </>
                ) : (
                    ""
                )}
                {this.state.loading_upload === true ? (
                    <div
                        className="overlay"
                        id="overlay"
                        style={{ display: "block" }}
                    >
                        <div className="overlayProgressBar">
                            <MDBProgress
                                material
                                value={this.state.progress}
                                height="20px"
                                color="danger"
                                striped
                            />
                        </div>
                    </div>
                ) : (
                    ""
                )}
                <MDBModalHeader toggle={this.props.toggleBulkUploadSubscribers}>
                    <h4>Bulk Upload Subscribers</h4>
                </MDBModalHeader>
                <MDBModalBody>
                    <div className="venueSelector">
                        <MDBRow>
                            <MDBCol col="6" sm="12" lg="4">
                                <h5>Venue Name:</h5>
                            </MDBCol>
                            <MDBCol col="6" sm="12" lg="8">
                                <SelectSearch
                                    id="selectVenue"
                                    search={true}
                                    filterOptions={fuzzySearch}
                                    options={this.props.optionTemplateVenues}
                                    isOptionSelected={true}
                                    inputId="venueArray"
                                    classNamePrefix="venue-select"
                                    placeholder="Select..."
                                    onChange={this.handleSelectChangeVenue}
                                    value={this.state.venueID}
                                />
                            </MDBCol>
                        </MDBRow>
                        <br />
                        <p>
                            Please note, only CSV files are accepted for the
                            upload. Fields marked with "*" in template are
                            required.
                        </p>
                        <p>
                            <strong>For special characters (ñ, é, ü, etc.):</strong> Save your CSV as "CSV UTF-8" in Excel or ensure UTF-8 encoding in other editors.
                        </p>
                        <p>
                            Select a venue to download a venue specific
                            template.
                        </p>
                    </div>
                    <div
                        className="text-right submitButton"
                        key={this.state.theInputKey || ""}
                    >
                        <MDBBtn
                            color="primary"
                            className="downloadButton"
                            disabled={!this.state.venueID || this.state.loading_units}
                            onClick={() => this.exportCSVFile(headers, itemsFormatted, fileTitle)}
                        >
                            {this.state.loading_units === true ? (
                                <div
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                >
                                    <span className="sr-only">Loading...</span>
                                </div>
                            ) : (
                                "Download Template"
                            )}
                        </MDBBtn>
                        <MDBBtn color="primary" disabled={!this.state.venueID || this.state.loading_units}>
                            Upload Subscribers
                            <CSVReader
                                cssclassName="csv-reader-input"
                                onFileLoaded={this.convertCSV}
                                parserOptions={papaparseOptions}
                                inputId="csvVenueUnitUploadData"
                                inputStyle={{ color: "transparent" }}
                                disabled={!this.state.venueID || this.state.loading_units}
                            />
                        </MDBBtn>
                        <MDBBtn
                            color="primary"
                            onClick={this.props.toggleBulkUploadSubscribers}
                        >
                            Close
                        </MDBBtn>
                    </div>
                </MDBModalBody>
            </>
        );
    }
}
export default BulkUploadSubscribers;
